module.exports = __webpack_public_path__ + "img/head-shoulders.5dbf9fce.png";